import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';

lessRequire('modules/shared/form-elements/radio.less');

const Checkbox = props => {
	const radioId = `${props.input.name}-${props.defaultValue}`;
	const isChecked = props.defaultValue == props.input.value;
	return (
		<div className={props.className || 'form-element-radio'}>
			<div className="radio">
				<input
					type="radio"
					id={radioId}
					disabled={props.shouldDisable}
					checked={isChecked}
					{...props.input}
					onChange={() => {
						props.input.onChange(props.defaultValue);
					} } />
				<label htmlFor={radioId}/>
			</div>
			{ props.labelText && (
				<label htmlFor={radioId} className="label-name">
					{props.labelText}
				</label>
			) }
		</div>
	);
};

Checkbox.propTypes = {
	input: PropTypes.object,
	defaultValue: PropTypes.string,
	labelText: PropTypes.string,
	className: PropTypes.string,
	shouldDisable: PropTypes.bool
};

export default Checkbox;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/radio.js